<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Edit Service</h1>
      </div>
    </div>
    <b-card class="mt-3">
      <div v-if="loading" class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
      <b-alert v-else-if="error" class="text-center" variant="danger" show>
        <p>Something went wrong...</p>
        <strong>error</strong>
        <router-link class="btn btn-primary" :to="{ name: 'services' }">
          Back to Services
        </router-link>
      </b-alert>
      <service-form
        v-else
        :service="service"
        :saving="saving"
        @submit="submit"
      ></service-form>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ServiceForm from './ServiceForm';

export default {
  components: {
    ServiceForm
  },
  methods: {
    ...mapActions({
      fetchService: 'services/fetchService',
      updateService: 'services/updateService'
    }),
    async submit(service) {
      try {
        this.saving = true;
        await this.updateService(service);
        this.$notify({
          type: 'success',
          text: 'Service updated'
        });
        this.$router.push({ name: 'services' });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      } finally {
        this.saving = false;
      }
    }
  },
  computed: {
    service() {
      return this.$store.getters['services/serviceById'](this.$route.params.id);
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      error: null
    };
  },
  async created() {
    const { id } = this.$route.params;

    if (!id) {
      this.$router.push({ name: 'services' });
    }

    try {
      if (!this.service) {
        await this.fetchService(id);
      }
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }
};
</script>
